const prefix = "LEVY_ESTIMATOR_";

export const PLAYGROUND_CALCULATE = prefix + "PLAYGROUND_CALCULATE";
export const PUBLIC_ESTIMATOR_GET = prefix + "PUBLIC_ESTIMATOR_GET";
export const PUBLIC_ESTIMATOR_CALCULATE = prefix + "PUBLIC_ESTIMATOR_CALCULATE";
export const VIEW = prefix + "VIEW";
export const VIEW_REFRESH = prefix + "VIEW_REFRESH";
